import React from "react";

const TravelIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 21V19C3 17.3431 4.34315 16 6 16H10C11.6569 16 13 17.3431 13 19V21M21 17V15C21 13.3431 19.6569 12 18 12H14M10 10C10 11.6569 8.65685 13 7 13C5.34315 13 4 11.6569 4 10C4 8.34315 5.34315 7 7 7C8.65685 7 10 8.34315 10 10ZM20 6C20 7.65685 18.6569 9 17 9C15.3431 9 14 7.65685 14 6C14 4.34315 15.3431 3 17 3C18.6569 3 20 4.34315 20 6Z"
        stroke="#3F3F46"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TravelIconDark;
